import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonDirective, ButtonIcon, ButtonLabel } from 'primeng/button';
import { Tag } from 'primeng/tag';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-access-denied-page',
  imports: [Tag, ButtonDirective, ButtonIcon, ButtonLabel],
  templateUrl: './access-denied-page.component.html',
})
export class AccessDeniedPageComponent implements OnInit {
  private userService = inject(UserService);
  private router = inject(Router);

  email = signal<string | null>(null);
  loading = signal(true);

  async ngOnInit() {
    try {
      const { account, membership, member } =
        await this.userService.fetchCurrentAccount();
      if (membership && member) {
        await this.router.navigateByUrl('/quotes');
        return;
      }
      this.email.set(account.email);
    } catch (error) {
      if (
        error instanceof HttpErrorResponse &&
        (error.status === 401 || error.status === 403)
      ) {
        // No signed-in account: nothing to explain, so sign in first.
        this.userService.redirectToLogin('/quotes');
        return;
      }
      // Anything else: still show the message, just without the email.
    }
    this.loading.set(false);
  }

  async signInWithDifferentAccount() {
    await this.userService.logout();
  }
}
